import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import InputText from "../../components/input/InputText";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import Draggable from "react-draggable";
import { useIsMobile } from "../../functions/isMobile";

const NewBookmark = (props) => {
  const isMobile = useIsMobile();
  const {
    newBookmarkPopup,
    setNewBookmarkPopup,
    saveCollectionFolder,
    setSubNewFolder,
    subNewFolder,
    title,
  } = props;
  const [name, setName] = useState("");

  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const handleSave = () => {
    saveCollectionFolder(name);
    setNewBookmarkPopup(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSave();
    }
  };
  useEffect(() => {
    const lastPosition = JSON.parse(localStorage.getItem("newCollectionPopup"));
    if (lastPosition) {
      setPosition(lastPosition);
    }
  }, []);

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  const handleDragStop = () => {
    localStorage.setItem("newCollectionPopup", JSON.stringify(position));
  };
  return (
    (newBookmarkPopup || subNewFolder) && (
      <>
        <div className="bg-dark-new" />
        {!isMobile ? (
          <Draggable
            defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
            onDrag={handleDrag}
            onStop={handleDragStop}
            cancel={isMobile ? ".new-bookmark-category-popup" : null}
          >
            <div
              onKeyDown={(e) => handleKeyDown(e)}
              className="new-bookmark-category-popup"
              tabIndex="0"
            >
              <div className="popup-card">
                <CloseIcon
                  className="cross"
                  onClick={() => {
                    setNewBookmarkPopup(false);
                    setSubNewFolder(false);
                  }}
                />

                {subNewFolder ? (
                  <p className="popup-title">
                    {`Create a subfolder within ${title}`}
                  </p>
                ) : (
                  <p className="popup-title">Create a new Collection</p>
                )}
                <InputText
                  placeholder="Enter new Collection name"
                  onChange={(e) => setName(e.target.value)}
                />
                {subNewFolder && (
                  <p className="desc">
                    Please note: Sharing Collections with others happens at the
                    parent-Collection level. All subfolders within a Collection
                    get automatically shared whenever the parent Collection is
                    shared.
                  </p>
                )}
                <div className="save-actions">
                  <div />
                  <div className="flex">
                    <ButtonPrimary
                      text="Cancel"
                      onClick={() => {
                        setNewBookmarkPopup(false);
                        setSubNewFolder(false);
                      }}
                      className="mr-2 grey"
                      outline
                    />
                    <ButtonPrimary text="Save" onClick={handleSave} />
                  </div>
                </div>
              </div>
            </div>
          </Draggable>
        ) : (
          <div
            onKeyDown={(e) => handleKeyDown(e)}
            className="new-bookmark-category-popup"
            tabIndex="0"
          >
            <div className="popup-card">
              <CloseIcon
                className="cross"
                onClick={() => {
                  setNewBookmarkPopup(false);
                  setSubNewFolder(false);
                }}
              />

              {subNewFolder ? (
                <p className="popup-title">
                  {`Create a subfolder within ${title}`}
                </p>
              ) : (
                <p className="popup-title">Create a new Collection</p>
              )}
              <InputText
                placeholder="Enter new Collection name"
                onChange={(e) => setName(e.target.value)}
              />
              {subNewFolder && (
                <p className="desc">
                  Please note: Sharing Collections with others happens at the
                  parent-Collection level. All subfolders within a Collection
                  get automatically shared whenever the parent Collection is
                  shared.
                </p>
              )}
              <div className="save-actions">
                <div />
                <div className="flex">
                  <ButtonPrimary
                    text="Cancel"
                    onClick={() => {
                      setNewBookmarkPopup(false);
                      setSubNewFolder(false);
                    }}
                    className="mr-2 grey"
                    outline
                  />
                  <ButtonPrimary text="Save" onClick={handleSave} />
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  );
};

export default NewBookmark;
